<template>
  <div class="mobile_style">
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <van-tabs
      v-model="active"
      @click="tab_click"
      title-active-color="#E0000F"
      title-style="font-weight: bold;font-size: 14px;"
    >
      <van-tab :title="i.title" v-for="(i, index) in tab_list" :key="index">
        <div class="card_style">
          <el-card
            v-for="item in order_list"
            :key="item.orderId"
            class="order_card_style"
          >
            <div slot="header">
              <div class="order_head">
                <div>
                  <div class="order_no_style">
                    <div class="express_num_style">{{ item.orderId }}</div>
                    <img
                      @click="copy_click"
                      class="copy_style"
                      data-clipboard-target=".express_num_style"
                      src="../assets/img/复制icon.png"
                      alt=""
                    />
                  </div>
                  <div class="order_time_style">{{ item.createTime }}</div>
                </div>
                <!-- <div class="order_status_style" v-if="item.payStatus == -1">已取消</div> -->
                <div class="order_status_style" v-if="item.payStatus == 0">
                  待支付
                </div>
                <div class="order_status_style" v-if="item.payStatus == 1">
                  待发货
                </div>
                <div class="order_status_style" v-if="item.payStatus == 2">
                  已发货
                </div>
              </div>
            </div>
            <div>
              <div class="order_desc_style">
                <img
                  :src="item.packageImg"
                  alt=""
                  style="width: 75px; height: 75px; border: 1px solid #ebeef5"
                />
                <div class="order_right_style">
                  <div class="package_name_style">
                    <span v-if="item.append == 1">【药品补充】</span>
                    <!-- <van-tag
                      v-if="item.append == 1"
                      color="#7232dd"
                      plain
                      size="medium"
                      >药品补充</van-tag
                    > -->
                    {{ item.packageName }}
                  </div>
                  <div v-if="!item.cgmSpuAppendList" class="rmb_layout_style">
                    <div class="rmb_style">￥{{ item.rmbAmount }}</div>
                    <div class="goods_num_style">x1</div>
                  </div>
                  <div class="spu_append_layout_style">
                    <div
                      v-for="item1 in item.cgmSpuAppendList"
                      :key="item1.spuAppendId"
                      class="spu_append_style"
                    >
                      <div class="append_spu_name_style">
                        {{ item1.spuName }}
                      </div>
                      <div class="spu_append_right_style">
                        <div class="append_rmb_style">
                          ￥{{ item1.rmbAmount }}
                        </div>
                        <div class="append_num_style">
                          x{{ item1.appendNum }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="order_total_style">
                <div class="order_amount_style">
                  总价￥{{ item.rmbAmount }}
                </div>
                <div class="order_amount_style">优惠￥0</div>
                <div class="order_real_style">
                  实付款￥{{ item.rmbAmount }}
                </div>
              </div>
              <div class="order_pay_style">
                <div
                  v-if="item.payStatus == 0"
                  class="repay_style"
                  @click="repay_click(item.orderId, item.vendor)"
                >
                  继续支付
                </div>
                <div
                  v-if="item.payStatus == 2"
                  class="track_style"
                  @click="track_click(item.expressName, item.expressNum)"
                >
                  物流轨迹
                </div>
              </div>
            </div>
          </el-card>
          <div v-if="order_list.length == 0" class="order_none_style">
            <div class="order_none_inner_style">
              <img src="../assets/img/无订单icon.png" alt="" />
              <div>您还没有相关的订单</div>
            </div>
          </div>
        </div>
      </van-tab>
      <!-- <van-tab title="待付款">内容 2</van-tab>
      <van-tab title="待发货">内容 3</van-tab>
      <van-tab title="已发货">内容 4</van-tab> -->
    </van-tabs>
    <!-- <el-dialog title="物流轨迹" :visible.sync="trackDialogVisible" center>
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in track_list"
          :key="index"
          :timestamp="item.ftime"
        >
          {{ item.context }}
        </el-timeline-item>
      </el-timeline>
      <span slot="footer" class="dialog-footer">
        <el-button @click="trackDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Clipboard from "clipboard";
import { Toast } from "vant";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      active: 0,
      size: 300,
      nihaopay_qr_code: null,
      payDialogVisible: false,
      order_list: [],
      trackDialogVisible: false,
      track_list: [],
      tab_list: [
        { title: "全部" },
        { title: "待支付" },
        { title: "待发货" },
        { title: "已发货" },
      ],
    };
  },
  mounted() {
    this.cgmOrderList();
  },
  methods: {
    copy_click() {
      const clipboard = new Clipboard(".copy_style");
      clipboard.on("success", function (e) {
        Toast.success("已复制");
        e.clearSelection();
      });
      clipboard.on("error", function (e) {
        Toast.success("复制失败");
      });
    },
    onClickLeft() {
      this.$router.push({
        path: "/menu",
      });
    },
    tab_click() {
      this.cgmOrderList();
    },
    cancel_click(orderId) {
      this.axios
        .post(
          "/cgmOrder/cancel",
          {
            orderId,
          },
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.cgmOrderList();
            Toast.success("已取消");
          }
        });
    },
    delete_click(orderId) {
      this.axios
        .post(
          "/cgmOrder/delete",
          {
            orderId,
          },
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.cgmOrderList();
            Toast.success("已删除");
          }
        });
    },
    pay_confirm_click() {
      this.cgmOrderList();
      this.payDialogVisible = false;
    },
    pay_click(codeUrl) {
      this.nihaopay_qr_code = codeUrl;
      this.payDialogVisible = true;
    },
    repay_click(orderId, vendor) {
      this.axios
        .post(
          "/reSecurePay",
          {
            orderId,
            vendor,
          },
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            let w = window.open("", "_self");
            w.document.write(res.data.data);
          }
        });
    },
    track_click(expressName, expressNum) {
      this.$router.push({
        path: "/track",
        query: {
          expressName,
          expressNum,
        },
      });
    },
    cgmOrderList() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .get("/cgmOrder/getOrderByUserId", {
          params: {
            userId,
            status: this.active - 1,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.order_list = res.data.data;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.order_time_style {
  font-size: 14px;
  line-height: 20px;
  color: #8a8a8a;
}
.order_no_style {
  font-size: 14px;
  line-height: 20px;
  color: #8a8a8a;
  display: flex;
  align-items: center;
}
.order_status_style {
  font-size: 14px;

  color: #e0000f;
}
.mobile_style {
  background: #f6f6f6;
}
::v-deep .el-dialog {
  width: 100% !important;
}
.order_style {
  padding: 40px;
  background: #f5f6f7;
}
.detail_style {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.o_style {
  margin-right: 10px;
  cursor: pointer;
}
.card_style {
  padding: 13px 15px 0 15px;
}
.order_none_style {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  color: #8a8a8a;
  height: 534px;
}
.order_none_inner_style {
  margin-top: 76px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.order_card_style {
  margin-bottom: 13px;
}
.repay_style {
  cursor: pointer;
  width: 83px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #e0000f;
  color: #e0000f;
  font-size: 14px;
}
.track_style {
  cursor: pointer;
  width: 83px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 14px;
  font-size: 14px;

  border-radius: 14px;
  border: 1px solid #bdbdbd;
  color: #8a8a8a;
}
.repay_style1 {
  color: #f56c6c;
}
.order_desc_style {
  display: flex;
  column-gap: 15px;
  margin-bottom: 8px;
}
.package_name_style {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 4px;
}
.order_right_style {
  width: 100%;
}
.rmb_layout_style {
  display: flex;
  align-items: center;
  column-gap: 13px;
  justify-content: flex-end;
}
.rmb_style {
  font-size: 12px;
  color: #000000;
}
.goods_num_style {
  font-size: 12px;
  color: #bdbdbd;
}
.spu_append_layout_style {
  width: 100%;
}
.spu_append_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.spu_append_right_style {
  display: flex;
  align-items: center;
}
.append_spu_name_style {
  font-size: 12px;
  color: #bdbdbd;
}
.append_rmb_style {
  font-size: 12px;
  color: #000000;
  margin-right: 13px;
}
.append_num_style {
  font-size: 12px;
  color: #bdbdbd;
}
.order_total_style {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 14px;
}
.order_amount_style {
  font-size: 12px;

  color: #bdbdbd;
}
.order_real_style {
  font-size: 14px;

  color: #000000;
}
.order_pay_style {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
}
.order_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.qr_style {
  display: flex;
  justify-content: center;
}
</style>